import $ from 'jquery'
import { lockScreen, unlockScreen } from './screenLocker'
import { isSP } from './checkScreen'

const $nav = $('#nav-global')
const $btnClose = $nav.find('.js-btn-close')
const OPEN_CLASS = 'is-active'

const navOpen = () => {
  $nav.addClass(OPEN_CLASS)
  lockScreen()
}

const navClose = () => {
  $nav.removeClass(OPEN_CLASS)
  unlockScreen()
}

const initBgSP = () => {
  $(window).on('scroll resize', () => {
    const $boxText = $('.c-mainvisual .box-text')
    const scrollTop = $(window).scrollTop()

    if (isSP() && $boxText.length) {
      const elementOffset = $boxText.offset().top - 50
      const distance = (elementOffset - scrollTop)

      if (elementOffset < scrollTop) {
        $('.c-header').addClass('is-white')
      } else {
        $('.c-header').removeClass('is-white')
      }
    } else if (isSP() && !$boxText.length) {
      if ($(window).scrollTop() > 50) {
        $('.c-header').addClass('is-white')
      } else {
        $('.c-header').removeClass('is-white')
      }
    } else if (!isSP()) {
      $('.c-header').removeClass('is-white')
    }
  })
}

const openButton = () => {
  const $menu = $('#nav-global').find('.js-btn-open')

  $menu.on('click', () => {
    if ($nav.hasClass(OPEN_CLASS)) {
      navClose()
    } else {
      navOpen()
    }
  })
}

const closeButton = () => {
  $btnClose.on('click', navClose)
}

const initNavGlobal = () => {
  // initOverlay()
  initBgSP()
  openButton()
  closeButton()
}

export default initNavGlobal
